import SportCourtAPI, { SportCourt } from "apis/SportCourtAPI";
import { fetchAction } from "store/actions/sportCourtActions";
import { SportCourtState } from "store/reducers/sportCourtReducer";
import reduxStoreWorker from "store/reduxStoreWorker";
import {
  getActiveSportCourtState,
  getSportCourtName,
  getSportCourtState,
} from "store/selectors/sportCourtSelectors";

const loadSportCourts = () => {
  const sportCourtState = getSportCourtState(
    reduxStoreWorker.getState()
  ) as SportCourtState;
  if (sportCourtState?.hasSportCourts) return;
  updateSportCourtOnRedux();
};

const updateSportCourtOnRedux = () => {
  return SportCourtAPI.listAll().then(({ data }) => {
    reduxStoreWorker.dispatch(fetchAction, data.sportCourts);
    return data;
  });
};

const getSportCourtNameById = (sportCourtId: string): string => {
  const sportCourt = getSportCourtName(reduxStoreWorker.getState())(
    sportCourtId
  );
  return sportCourt?.name || "";
};

const getActiveSportCourts = (): SportCourt[] => {
  return getActiveSportCourtState(reduxStoreWorker.getState());
};

const sportCourtReduxWorker = {
  loadSportCourts,
  updateSportCourtOnRedux,
  getSportCourtNameById,
  getActiveSportCourts,
};

export default sportCourtReduxWorker;
